const Share = (props) => (props && {
  title: props.title,
  image: props.picture,
  description: props.description,
})

export default Share
